import { render, staticRenderFns } from "./StandeePriceTab.vue?vue&type=template&id=0c3fa569&"
import script from "./StandeePriceTab.ts?vue&type=script&lang=js&"
export * from "./StandeePriceTab.ts?vue&type=script&lang=js&"
import style0 from "./StandeePriceTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports